import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import Toggle from 'components/Toggle';

const Container = styled.div`
	padding: 40px 0 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const MoveIn = props => {
	const { t } = props;

	return (
		<Container>
			<Label>{t('brochure/Controls/Page/Move in logo')}</Label>
			<Toggle
				isOn={props.moveIn}
				onChange={checked => {
					props.updatePageSettingsHandler({
						moveIn: checked,
					})
				}}
			/>
		</Container>
	)
}

MoveIn.propTypes = {
	t: PropTypes.func,
	moveIn: PropTypes.bool,
	updatePageSettingsHandler: PropTypes.func,
}

export default translate('translations')(MoveIn)
